import { createTheme, responsiveFontSizes } from "@mui/material"

const theme = createTheme({
  typography: {
    button: {
      textTransform: "none",
    },
    fontFamily: "'Poppins', sans-serif"
  },


  palette: {
    mode: "light",
    primary: {
      main: "#94FF7A",
      light: "#42FF14",
      dark: "#22AD00",
    },
    secondary: {
      main: "#303287",
      dark: "#15163B",
      light: "#5A5CC4",
    },
    error: {
      main: "#E9132D",
      dark: "#E9132D40",
      light: "#A91123",
    },
    text: {
      primary: "#333333",
      secondary: "#4D4D4D",
      disabled: "#999999",
    },


    background: {
      default: "#E6E6E6",
    },
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },



})
export default responsiveFontSizes(theme)
